import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { ElectionStatusEnum } from 'src/app/enums/ElectionStatusEnum';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { IElectionDate } from 'src/app/interfaces/IElectionDate';
import { ElectionService } from 'src/app/services/election.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements AfterViewInit, OnDestroy {

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  // public historyDistrictNames: string[] = [];
  public countDistrictNames: string[] = [];
  public selectedDistrict: string | null = null;
 // public selectedHistoryDistrict: string | null = null;
  public showCountDistricts = false;
  public ElectionStatusEnum = ElectionStatusEnum;

  public elections: IElectionDate[] = [];
  public selectedButton = '';

  constructor(private electionService: ElectionService) {
    this.electionService.menuLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe((electionDateString: string) => {
      this.loadMenu(electionDateString);
    });
    this.electionService.countDownComplete$.subscribe(() => {
      this.buttonByElectionDistrictClick('2022-07-02', 'Bragg'); // TODO
    });
  }


  ngAfterViewInit(): void {
    if (this.electionService.electionDates.length > 0) {
      this.loadMenu(this.electionService.electionDates[0]?.electionDateString);
    }
  }


  private loadMenu(electionDateString: string): void {
    const electionDate = this.electionService.electionDates[0];

    this.elections = this.electionService.electionDates;
    const firstDistrict: string | null =
      electionDate.districts && electionDate.districts.length > 0 ? electionDate.districts[0] : null;
    this.countDistrictNames = [];

    // On initial load (page is still Loading), default to HA statewide results,
    // not a specific district. The user can then choose a district explicitly.
    if (this.electionService.selectedPage?.pageType === PageTypeEnum.Loading) {
      this.selectedDistrict = null;
      this.setSelectedButton('HAStateWide', electionDateString, '');
      this.electionService.updatePage(
        electionDateString,
        PageTypeEnum.CountHAStateWide,
        null,
        new Date(electionDateString)
      );
    }
  }

  public setSelectedButton(pageType: string, electionDateString: string, district: string | null): void {
    this.selectedButton = pageType + electionDateString + (district ?? '');
  }

  public clearDistricts(): void {
    this.showCountDistricts = false;
  }


  public clickDistrict(electionDateString: string, district: string): void {
    this.selectedDistrict = district;
    this.countDistrictNames = this.electionService.electionMap.get(electionDateString)?.electionCount?.districtList ?? [];
    this.electionService.checkMenu();
    this.electionService.updatePage(
      electionDateString,
      PageTypeEnum.CountHADistrict,
      this.selectedDistrict,
      new Date(electionDateString)
    );
  }

  public buttonByElectionDistrictClick(electionDateString: string, district: string): void {
    this.setSelectedButton('byElectionDistrict', electionDateString, district);
    this.electionService.checkMenu();
    this.clearDistricts();
    this.electionService.updatePage(
      electionDateString,  // TODO:
      this.electionService.isTestingMode || this.electionService.isCountingStarted ?  PageTypeEnum.CountHADistrict : PageTypeEnum.CountDown,
      district,
      new Date(electionDateString)
    );
  }

  public buttonCountDistrictClick(electionDateString: string): void {

    this.setSelectedButton('HAStateWideDistrict', electionDateString, '');
    this.showCountDistricts = !this.showCountDistricts;
    this.countDistrictNames = this.electionService.electionMap.get(electionDateString)?.electionCount?.districtList ?? [];
    if (this.selectedDistrict === null) {
      this.selectedDistrict = this.countDistrictNames.length > 0 ? this.countDistrictNames[0] : 'Adelaide';
    }
    this.electionService.updatePage(
      electionDateString,
      PageTypeEnum.CountHADistrict,
      this.selectedDistrict,
      new Date(electionDateString)
    );
 //   this.electionService.checkMenu();
  }


  public buttonCountStateWideClick(electionDateString: string): void {
    this.setSelectedButton('HAStateWide', electionDateString, '');
    this.electionService.checkMenu();
    this.clearDistricts();
    this.electionService.updatePage(
      electionDateString,
      PageTypeEnum.CountHAStateWide,
      null,
      new Date(electionDateString)
    );
  }


  public buttonCountLCStateWideClick(electionDateString: string): void {
    this.setSelectedButton('LCStateWide', electionDateString, '');
    this.electionService.checkMenu();
    this.clearDistricts();
    this.electionService.updatePage(
      electionDateString,
      PageTypeEnum.CountLCStateWide,
      null,
      new Date(electionDateString)
    );
  }


  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
